import Keycloak from 'keycloak-js';
import { ClearAnalyticsExpiredData } from '~/utils/ClearAnalyticsExpiredData';

const {
  VITE_KEYCLOAK_IAM_URL,
  VITE_KEYCLOAK_REALM,
  VITE_KEYCLOAK_CLIENT_ID,
  VITE_KEYCLOAK_IDP_HINT,
} = import.meta.env;

const _kc = new Keycloak({
  url: VITE_KEYCLOAK_IAM_URL,
  realm: VITE_KEYCLOAK_REALM,
  clientId: VITE_KEYCLOAK_CLIENT_ID,
});

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback - Callback function to be called when authentication is successful.
 * @param onUnauthenticatedCallback - Callback function to be called when authentication fails.
 */
const initKeycloak = async (
  onAuthenticatedCallback,
  onUnauthenticatedCallback,
  onAuthenticatingCallback
) => {
  onAuthenticatingCallback();
  // onAuthenticatedCallback();

  try {
    const authenticated = await _kc.init({
      onLoad: 'check-sso',
      flow: 'standard',
      pkceMethod: 'S256',
    });

    if (authenticated) {
      onAuthenticatedCallback();
      ClearAnalyticsExpiredData();
      return;
    }

    const loginOptions = {};
    if (VITE_KEYCLOAK_IDP_HINT) {
      loginOptions.idpHint = VITE_KEYCLOAK_IDP_HINT;
    }
    const loginUrl = await _kc.createLoginUrl(loginOptions);

    window.location.replace(loginUrl);
  } catch (error) {
    console.error('Failed to initialize adapter:', error);
    onUnauthenticatedCallback();
  }
};

const doLogin = _kc?.login;

const doLogout = () => {
  _kc.logout();
};

const getToken = () => _kc?.token;

const isLoggedIn = () => !!_kc?.token;

const getUsername = () => _kc?.idTokenParsed?.name;

const isAuthenticated = () => _kc?.authenticated;

const getKeycloakConfig = () => _kc;

const UserService = {
  doLogin,
  initKeycloak,
  doLogout,
  isLoggedIn,
  getToken,
  getUsername,
  isAuthenticated,
  getKeycloakConfig,
};

export default UserService;
